<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-05-06 09:41:51
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-09 14:31:13
-->
<template>
  <el-select
    v-model="editSelect"
    :placeholder="inputTip"
    class="cashierdiary--select"
    filterable
    clearable
    popper-class = "cashierdiary--select-popper"
    @change="$emit('change',$event)"
    :multiple="multiple"
  >
    <span v-for="i in optionList" style="display: block;width: 100%;position: relative;" :key = "i.id">
    	 <span class='cashierdiary--select-dotColor' :style="{ background: i.color}"></span>
    	 <el-option
          :key="i.id"
          style="display: inline-block;width: 100%;padding-left: 30px;font-size: 12px;"
          :label="i.optionName"
          :value="i.id">
        </el-option>
    </span>
    <div class = "cashierdiary--select-addItem pointer" @click = "$emit('addSelectOption',true)">
        <i class="el-icon-plus"></i> 
        添加选项
    </div>
  </el-select>
</template>

<script>
  export default {
    props:{
      inputTip:{
        type:String,
        default:"请选择"
      },
      value:[String,Number,Array],  // 当前选中值
      optionList:[Array],  // 下拉选项
      multiple:[Boolean],  // 是否多选
    },
    data() {
      return {

      }
    },
    computed:{
      editSelect:{
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    methods:{

    }
  }
</script>

<style lang="less" scoped>
  @import "../../../../../assets/css/cashierdiary/input.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/c-select.vue